import {applyMiddleware, createStore} from 'redux';
import {thunk} from "redux-thunk";
import {rootReducer} from "./rootReducer";
import productMonitoring from "../services/log/productMonitoring";
import {composeWithDevTools} from "@redux-devtools/extension";
import {isAppEnvDev, isAppEnvLocalDev} from "../config/environment";
import { persistStore } from 'redux-persist';
import * as Sentry from '@sentry/react';

// name redux per build env
const reduxOptionAppName = `playground-web-app`;
let reduxOptionAppNameSuffix = ``;
if (isAppEnvDev) {
  reduxOptionAppNameSuffix += `.dev`;
}
if (isAppEnvLocalDev) {
  reduxOptionAppNameSuffix += `.local`;
}

// if app is dev build, then open more details for debug
const devReduxOptions = {
  trace: true,
  traceLimit: 20,
};

const composeEnhancers = composeWithDevTools({
  name: `${reduxOptionAppName}${reduxOptionAppNameSuffix}`,
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
  // @see https://github.com/reduxjs/redux-devtools/blob/main/extension/docs/API/Arguments.md#name
  ...(isAppEnvDev ? devReduxOptions : {}),
});
function configureStore(){
  const store = composeEnhancers(
    applyMiddleware(thunk),
    applyMiddleware(...productMonitoring.getReduxMiddlewares()),
    Sentry.createReduxEnhancer({
      /** @link https://docs.sentry.io/platforms/javascript/guides/react/features/redux/#redux-enhancer-options */
    }),
  )(createStore)(rootReducer,);
  const storePersistControl  = persistStore(store);
  return {store, storePersistControl };
}

export const {store, storePersistControl } = configureStore();
